import { render } from "./UserRequestRegisterForm.vue?vue&type=template&id=6d4af947"
import script from "./UserRequestRegisterForm.vue?vue&type=script&lang=js"
export * from "./UserRequestRegisterForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/fishing-license/fishing-license-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__